import { useLingui } from '@lingui/react';
import { ScrollArea, SegmentedControl } from '@mantine/core';
import { IconBallBasketball, IconBrandBinance, IconLayoutGridFilled, IconNews, IconSpeakerphone } from '@tabler/icons-react';
import { useState } from 'react';
import { Icons } from '../Shares/Icons';
import classes from './BlogFilter.module.css';
import { BlogFilterLabel } from './BlogFilterLabel';
export const BlogFilter: React.FC = () => {
  const [value, setValue] = useState('all');
  const {
    i18n
  } = useLingui();
  return <ScrollArea w="100%" maw={870} scrollbars="x" type="never">
      <SegmentedControl maw={870} w="100%" size="md" value={value} onChange={setValue} classNames={classes} data={[{
      value: 'all',
      label: <BlogFilterLabel label={i18n._('All')}>
                <IconLayoutGridFilled size={24} />
              </BlogFilterLabel>
    }, {
      value: 'casino',
      label: <BlogFilterLabel label={i18n._('Casino')}>
                <Icons className="icon-pr-flat-playing-cards" fontSize={24} />
              </BlogFilterLabel>
    }, {
      value: 'sports',
      label: <BlogFilterLabel label={i18n._('Sports')}>
                <IconBallBasketball size={24} />
              </BlogFilterLabel>
    }, {
      value: 'crypto',
      label: <BlogFilterLabel label={i18n._('Crypto')}>
                <IconBrandBinance size={24} />
              </BlogFilterLabel>
    }, {
      value: 'news',
      label: <BlogFilterLabel label={i18n._('News')}>
                <IconNews size={24} />
              </BlogFilterLabel>
    }, {
      value: 'promotions',
      label: <BlogFilterLabel label={i18n._('Promotions')}>
                <IconSpeakerphone size={24} />
              </BlogFilterLabel>
    }, {
      value: 'tutorials',
      label: <BlogFilterLabel label={i18n._('Tutorials')}>
                <Icons className="icon-pr-flat-info" fontSize={24} />
              </BlogFilterLabel>
    }]} />
    </ScrollArea>;
};